import React from "react"
import "./residency.css"

const residency = () => {
  return (
    <div>
      <div className="squareresidency">
        <div className="squareresidency-top" data-aos="fade-right"
          data-aos-offset="300"
          data-aos-easing="ease-in-sine">
          <img src="./SquarePhotos/Residency/residency.jpeg" alt="building" />
        </div>
        <div className="squareresidency-bottom" data-aos="fade-left"
          data-aos-offset="300"
          data-aos-easing="ease-in-sine">
          <h3>WELCOME TO<br/> AVENUE ONE<br/> THE SQUARE</h3>
          <p>The Square by Avenue One is the flagship project of Avenue One Developments a premium
            high-rise, mixed-use project combining commercial spaces and residential apartments in one
            modern landmark.
          </p>
          <p>The Square by Avenue One designed for business visibility, refined vertical living, and long-term urban value, The Square
            brings together high-end commercial floors, residential apartments, smart building features,
            backup power, security, managed services, and a premium building experience.
          </p>
        </div>
      </div>
    </div>
  )
}

export default residency